var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 4.77338C11.9597 4.76671 11.9131 4.76671 11.8731 4.77338C10.9531 4.74004 10.2197 3.98671 10.2197 3.05338C10.2197 2.10004 10.9864 1.33337 11.9397 1.33337C12.8931 1.33337 13.6597 2.10671 13.6597 3.05338C13.6531 3.98671 12.9197 4.74004 11.9997 4.77338Z",
    stroke: "#F2F2F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.313 9.62669C12.2263 9.78003 13.233 9.62003 13.9396 9.14669C14.8796 8.52003 14.8796 7.49336 13.9396 6.86669C13.2263 6.39336 12.2063 6.23336 11.293 6.39336",
    stroke: "#F2F2F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.98031 4.77338C4.02031 4.76671 4.06698 4.76671 4.10698 4.77338C5.02698 4.74004 5.76031 3.98671 5.76031 3.05338C5.76031 2.10004 4.99365 1.33337 4.04031 1.33337C3.08698 1.33337 2.32031 2.10671 2.32031 3.05338C2.32698 3.98671 3.06031 4.74004 3.98031 4.77338Z",
    stroke: "#F2F2F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66663 9.62669C3.75329 9.78003 2.74663 9.62003 2.03996 9.14669C1.09996 8.52003 1.09996 7.49336 2.03996 6.86669C2.75329 6.39336 3.77329 6.23336 4.68663 6.39336",
    stroke: "#F2F2F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0007 9.75336C7.9607 9.74669 7.91404 9.74669 7.87404 9.75336C6.95404 9.72002 6.2207 8.96669 6.2207 8.03336C6.2207 7.08002 6.98737 6.31335 7.9407 6.31335C8.89403 6.31335 9.6607 7.08669 9.6607 8.03336C9.65404 8.96669 8.9207 9.72669 8.0007 9.75336Z",
    stroke: "#F2F2F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.06047 11.8534C5.12047 12.48 5.12047 13.5067 6.06047 14.1334C7.12714 14.8467 8.8738 14.8467 9.94047 14.1334C10.8805 13.5067 10.8805 12.48 9.94047 11.8534C8.88047 11.1467 7.12714 11.1467 6.06047 11.8534Z",
    stroke: "#F2F2F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.5e87b9b859f0e9792f9815182bcac0ef.svg";
export { ForwardRef as ReactComponent };